import React, { useEffect, useState } from 'react';
import menuData from './menuData.json';

import { Menu, MenuItem, MenuButton, SubMenu } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import { ChevronDown } from 'lucide-react';

type DropdownProp = {
  disabled?: boolean;
  selectedValue?: { item: string; id: number };
  id?: number;
  setSelectedValue: React.Dispatch<
    React.SetStateAction<{
      id: number;
      item: string;
    }>
  >;
  studentTopic: string;
};

export default function Dropdown({ disabled, id, setSelectedValue, studentTopic }: DropdownProp) {
  const [selectedItem, setSelectedItem] = useState('');
  useEffect(() => {
    setSelectedItem(studentTopic);
  }, [studentTopic, disabled]);
  const handleSelectItem = (item: string) => {
    setSelectedItem(item);
    if (id !== undefined) {
      setSelectedValue({ id: id, item: item });
    }
  };

  return (
    <Menu
      menuButton={
        <MenuButton className='select-box mt-2 outline-none justify-between focus:outline-none disabled:cursor-not-allowed border px-3 py-2 bg-white rounded-sm flex items-center min-w-32 w-full' disabled={disabled}>
          {studentTopic ? studentTopic : selectedItem || 'Choose Topic'}
          <ChevronDown className='h-4 w-4' />
        </MenuButton>
      }
    >
      {menuData.menus.map((menu, index) => (
        <SubMenu key={index} label={menu.name}>
          {menu.submenus.map((item, subIndex) => (
            <MenuItem
              key={subIndex}
              onClick={() => {
                handleSelectItem(item.name);
              }}
            >
              {item.name}
            </MenuItem>
          ))}
        </SubMenu>
      ))}
    </Menu>
  );
}
